// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"c99750fc","703":"a02b5884"}[chunkId] + ".chunk.js";
};